module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_26.a4e8f760.png";